export default "__VITE_ASSET__a3c06e91__"